export default __webpack_public_path__ + "static/media/face.8f9b6985.svg";